import React from "react";
import { UICheckbox } from "components/ui";

import "./styles.css";

/**
 * @function UsersListCheckboxRow
 * @param {STRING} username - Sets the username text
 * @return {React.Component}
 * @exported true
 * @description This is the users list checkbox row used for the UserListWidget
 */
export default function UsersListCheckboxRow(props) {
    const userAccount = props.userAccount ?? {};
    const achTemplate = props.achTemplate ?? {};
    const hasACHTemplateSelected = Object.keys(achTemplate).length > 0;
    const username = props.username ?? "[username]";
    const checked = props.checked ?? "";
    const onDenyAllClick = props.onDenyAllClick ?? undefined;
    const onCheckboxClick = props.onCheckboxClick ?? undefined;

    return (
        <div className="user-list-checkbox-row">
            <div className="user-list-checkbox-row-container flex-container align-center">
                <div className="flex-width">
                    <span className="username-text">{ username }</span>
                </div>
                <div className="set-width">
                    <UICheckbox key={ Object.keys(userAccount).length > 0 ? userAccount.id : achTemplate.id } className="username-checkbox" label="" value={ checked } 
                    onChange={ onDenyAllClick ? onDenyAllClick(hasACHTemplateSelected ? achTemplate : userAccount) : onCheckboxClick(Object.keys(userAccount).length > 0 ? userAccount : achTemplate )  }/>
                </div>
            </div>
        </div>
    )
}
